import { AnyAction } from 'redux';
import { PaginatedResponse } from '@synergy/api';
import { defaultPageSize } from '@synergy/config';

import { DEMAND_DETAIL_DECLINED } from '../../demands-detail/store/demands-detail-actions';
import { DemandOverview } from '../models/demand-overview';
import { RECEIVE_DEMAND_OVERVIEW, REQUEST_DEMAND_OVERVIEW, RESET_DEMANDS_OVERVIEW } from './demands-overview-actions';

export interface DemandsOverviewReducerState {
    data: PaginatedResponse<DemandOverview>;
    requesting: boolean;
}

const initialDemandOverviewReducerState: DemandsOverviewReducerState = {
    data: { items: [], total: 0, page: 1, limit: defaultPageSize },
    requesting: false,
};

export const demandsOverviewReducer = (
    state: DemandsOverviewReducerState = initialDemandOverviewReducerState,
    action: AnyAction
): DemandsOverviewReducerState => {
    const { type, ...rest } = action;
    switch (type) {
        case REQUEST_DEMAND_OVERVIEW: {
            return {
                ...state,
                requesting: true,
            };
        }

        case RECEIVE_DEMAND_OVERVIEW: {
            return {
                ...state,
                data: rest['paginatedDemandOverview'],
                requesting: false,
            };
        }

        case DEMAND_DETAIL_DECLINED: {
            return {
                ...state,
                requesting: true,
            };
        }

        case RESET_DEMANDS_OVERVIEW: {
            return {
                ...state,
                data: initialDemandOverviewReducerState.data,
            };
        }

        default: {
            return state;
        }
    }
};
